<template>
  <div name="logical-statement">
    <div class="btn -minor bg-dark-gray" :class="disableMode ? 'disabled' : ''" data-toggle="modal" :data-target="!disableMode ? '#logical-statement-popup' : ''">
      Advanced Search
    </div>
    <div class="summary-logical" v-show="submitDescStmt !== ''">
      {{submitDescStmt}}
    </div>
    <div class="validate-box">
      <span v-show="!validStmt" class="validate-text">Valid Statement: {{validStmt}}</span>
    </div>
    <popup  :lists="myLists"
            :nowLang="nowLang"
            :labelCodsex="labelCodsex[nowLang]"
            :listFields="listFields[nowLang]"
            :listConjunctions="listConjunctions[nowLang]"
            :listOperators="listOperators[nowLang]"
            :viewList="viewList"
            :editList="editList"
            :deleteList="deleteList"
            :linkList="linkList"
            :unlinkList="unlinkList"
            :groupList="groupList"
            :ungroupList="ungroupList"
            :setDescConjAndDescStmt="setDescConjAndDescStmt"
            @setLists="myLists = arguments[0]"
            :totalEdit="totalEdit"
            :totalLink="totalLink"
            :validStmt="validStmt"
            :rootNode="myLists.length === 0"
            :list="list"
            :listDisp="listDisp"
            :objConj="objConj"
            :addList="addList"
            :resetLists="resetLists"
            :back="back"
            :submit="submit"
            :findValueType="findValueType"
            :findInputType="findInputType"
            :findLovType="findLovType"
            :showAddList="showAddList" />
  </div>
</template>

<script>
  import popup from 'components/hrmsLogicalStatement/popup'
  import { mapGetters } from 'vuex'
  import * as lovTypes from 'store/modules/hrmsLov/mutation-types'
  import * as lovCodcompTypes from 'store/modules/hrmsLovCodcomp/mutation-types'
  import _ from 'lodash'
  const crypto = require('crypto')

  export default {
    name: 'logical-statement',
    components: {
      popup
    },
    data () {
      return {
        myLists: this.lists,
        list: this.initialList(),
        listDisp: false,
        objConj: this.initialConjunction(),
        submitCodeStmt: this.value.code,
        submitDescStmt: this.value.description,
        validStmt: true,
        listConjunctions: {
          en: {
            'and': 'And',
            'or': 'Or'
          },
          th: {
            'and': 'และ',
            'or': 'หรือ'
          }
        },
        listOperators: {
          en: [
            { code: '=', description: 'EQUAL TO', type: [ 'varchar2', 'number', 'date' ] },
            { code: '>', description: 'MORE THAN', type: [ 'varchar2', 'number', 'date' ] },
            { code: '<', description: 'LESS THAN', type: [ 'varchar2', 'number', 'date' ] },
            { code: '<>', description: 'NOT EQUAL TO', type: [ 'varchar2', 'number', 'date' ] },
            { code: '<=', description: 'NOT MORE THAN', type: [ 'varchar2', 'number', 'date' ] },
            { code: '>=', description: 'NOT LESS THAN', type: [ 'varchar2', 'number', 'date' ] },
            { code: '_%', description: 'START WITH', type: [ 'varchar2' ] },
            { code: '%_', description: 'END WITH', type: [ 'varchar2' ] },
            { code: '%_%', description: 'COMPOSED OF', type: [ 'varchar2' ] },
            { code: '!%_%', description: 'NOT COMPOSED OF', type: [ 'varchar2' ] }
          ],
          th: [
            { code: '=', description: 'เท่ากับ', type: [ 'varchar2', 'number', 'date' ] },
            { code: '>', description: 'มากกว่า', type: [ 'varchar2', 'number', 'date' ] },
            { code: '<', description: 'น้อยกว่า', type: [ 'varchar2', 'number', 'date' ] },
            { code: '<>', description: 'ไม่เท่ากับ', type: [ 'varchar2', 'number', 'date' ] },
            { code: '<=', description: 'ไม่มากกว่า', type: [ 'varchar2', 'number', 'date' ] },
            { code: '>=', description: 'ไม่น้อยกว่า', type: [ 'varchar2', 'number', 'date' ] },
            { code: '_%', description: 'ขึ้นต้นด้วย', type: [ 'varchar2' ] },
            { code: '%_', description: 'ลงท้ายด้วย', type: [ 'varchar2' ] },
            { code: '%_%', description: 'ที่ประกอบด้วย', type: [ 'varchar2' ] },
            { code: '!%_%', description: 'ที่ไม่ประกอบด้วย', type: [ 'varchar2' ] }
          ]
        },
        labelCodsex: {
          en: {
            'M': 'male',
            'F': 'female'
          },
          th: {
            'M': 'ชาย',
            'F': 'หญิง'
          }
        }
      }
    },
    watch: {
      lists (newVal) {
        this.myLists = newVal
      },
      myLists (newVal) {
        this.$emit('setLists', newVal)
      },
      value (newVal) {
        this.submitCodeStmt = newVal.code
        this.submitDescStmt = newVal.description
      },
      submitCodeStmt (newVal) {
        this.$emit('input', { code: newVal, description: this.submitDescStmt })
        this.$emit('changeStatement')
      },
      submitDescStmt (newVal) {
        this.$emit('input', { code: this.submitCodeStmt, description: newVal })
        this.$emit('changeStatement')
      }
    },
    props: {
      value: {
        type: Object,
        required: true
      },
      nowLang: {
        type: String,
        default: 'en'
      },
      lists: {
        type: Array,
        default () {
          return []
        }
      },
      disableMode: {
        type: Boolean,
        default: false
      },
      listFields: {
        type: Object,
        default () {
          return {
            en: [
              {
                code: 'V_HRMS11.CODEMPID',
                description: 'employee code',
                type: 'varchar2',
                input: 'lov'
              }, {
                code: 'V_HRMS11.NAMFIRSTE',
                description: 'employee name',
                type: 'varchar2',
                input: 'input'
              }, {
                code: 'V_HRMS11.NUMLVL',
                description: 'level number',
                type: 'number',
                input: 'input'
              }, {
                code: 'V_HRMS11.DTESTRT',
                description: 'start date',
                type: 'date',
                input: 'date'
              }
            ],
            th: [
              {
                code: 'V_HRMS11.CODEMPID',
                description: 'รหัสพนักงาน',
                type: 'varchar2',
                input: 'lov'
              }, {
                code: 'V_HRMS11.NAMFIRSTE',
                description: 'ชื่อพนักงาน',
                type: 'varchar2',
                input: 'input'
              }, {
                code: 'V_HRMS11.NUMLVL',
                description: 'ระดับพนักงาน',
                type: 'number',
                input: 'input'
              }, {
                code: 'V_HRMS11.DTESTRT',
                description: 'วันที่เริ่มต้น',
                type: 'date',
                input: 'date'
              }
            ]
          }
        }
      }
    },
    computed: {
      totalEdit () {
        return this.myLists.filter(function (list) {
          return list.flgEdit
        }).length
      },
      totalLink () {
        return this.myLists.filter(function (list) {
          return list.flgLink
        }).length
      },
      ...mapGetters({
        lovCurrentDesc: lovTypes.GET_LOV_CURRENT_DESC,
        lovCodcompCurrentDesc: lovCodcompTypes.GET_LOV_CODCOMP_CURRENT_DESC
      })
    },
    methods: {
      hashCode () {
        return crypto.randomBytes(20).toString('hex')
      },
      initialList () {
        return {
          field: '',
          operator: '',
          value: ''
        }
      },
      initialConjunction () {
        return {
          descConj: '',
          conj: ''
        }
      },
      getDescCodsex (codsex) {
        return this.labelCodsex[this.nowLang][codsex]
      },
      findValueType (field) {
        let listFieldIndex = this.listFields[this.nowLang].map(function (listField) {
          return listField.code
        }).indexOf(field)
        if (listFieldIndex > -1) {
          return this.listFields[this.nowLang][listFieldIndex].type || 'varchar2'
        } else {
          return 'varchar2'
        }
      },
      findInputType (field) {
        let listFieldIndex = this.listFields[this.nowLang].map(function (listField) {
          return listField.code
        }).indexOf(field)
        if (listFieldIndex > -1) {
          return this.listFields[this.nowLang][listFieldIndex].input || 'input'
        } else {
          return 'input'
        }
      },
      findLovType (field) {
        if (field) {
          return field.split('.')[1].toLowerCase()
        }
        return ''
      },
      addList ({ newList, addStmtDisp }, { newObjConj, addConjDisp }) {
        if (this.myLists.length > 0 && addConjDisp) {
          newObjConj = this.setDescConjAndDescStmt(newObjConj)
          newObjConj.id = this.hashCode()
          this.myLists.push(newObjConj)
          this.$set(this.myLists[this.myLists.length - 1], 'flgEdit', false)
          this.$set(this.myLists[this.myLists.length - 1], 'flgLink', false)
        }
        if (addStmtDisp) {
          newList = this.setDescConjAndDescStmt(newList)
          newList.id = this.hashCode()
          this.myLists.push(newList)
          this.$set(this.myLists[this.myLists.length - 1], 'flgEdit', false)
          this.$set(this.myLists[this.myLists.length - 1], 'flgLink', false)
        }
        this.list = this.initialList()
        this.listDisp = false
        this.objConj = this.initialConjunction()
      },
      setDescConjAndDescStmt (newOrEditList) {
        if (typeof newOrEditList.conj !== 'undefined') {
          newOrEditList.descConj = this.listConjunctions[this.nowLang][newOrEditList.conj]
        }
        if (typeof newOrEditList.field !== 'undefined') {
          let operator = ''
          let value = ''
          let descValue = newOrEditList.value
          if (this.findInputType(newOrEditList.field) === 'lov') {
            let lovType = this.findLovType(newOrEditList.field)
            if (this.findLovType(newOrEditList.field) === 'codcomp') {
              descValue = this.lovCodcompCurrentDesc(_.padEnd(descValue, 21, '0'))
            } else if (this.findLovType(newOrEditList.field) === 'codsex') {
              descValue = this.getDescCodsex(descValue)
            } else {
              descValue = this.lovCurrentDesc(lovType, descValue)
            }
          }
          if (newOrEditList.operator.indexOf('%') > -1) {
            operator = 'like'
            if (newOrEditList.operator === '_%') {
              value = newOrEditList.value + '%'
            }
            if (newOrEditList.operator === '%_') {
              value = '%' + newOrEditList.value
            }
            if (newOrEditList.operator === '%_%') {
              value = '%' + newOrEditList.value + '%'
            }
            if (newOrEditList.operator === '!%_%') {
              operator = 'not like'
              value = '%' + newOrEditList.value + '%'
            }
          } else {
            operator = newOrEditList.operator
            value = newOrEditList.value
          }
          value = '\'' + value + '\''
          if (this.findValueType(newOrEditList.field) === 'number') {
            value = 'to_number(' + value + ')'
          } else if (this.findValueType(newOrEditList.field) === 'date') {
            value = 'to_date(' + value + ', \'DD/MM/YYYY\')'
          }
          let listFieldIndex = this.listFields[this.nowLang].map(function (listField) {
            return listField.code
          }).indexOf(newOrEditList.field)
          let listOperatorIndex = this.listOperators[this.nowLang].map(function (listOperator) {
            return listOperator.code
          }).indexOf(newOrEditList.operator)
          newOrEditList.codeStmt = `${newOrEditList.field} ${operator} ${value}`
          newOrEditList.descStmt = `${this.listFields[this.nowLang][listFieldIndex].description} ${this.listOperators[this.nowLang][listOperatorIndex].description} ${descValue}`
        }
        return newOrEditList
      },
      resetLists () {
        this.myLists = []
      },
      back () {
        this.list = this.initialList()
        this.listDisp = false
        this.objConj = this.initialConjunction()
      },
      submit () {
        for (let list of this.myLists) {
          list.flgEdit = false
        }
        this.submitDescStmt = ''
        this.submitCodeStmt = ''
        this.validStmt = this.validateStmtLists(this.myLists)
        if (this.validStmt) {
          if (this.myLists.length <= 0) {
            this.submitCodeStmt = ''
            this.submitDescStmt = ''
          } else if (this.myLists.length === 1) {
            this.submitCodeStmt = this.myLists[0].codeStmt
            this.submitDescStmt = this.myLists[0].descStmt
          } else {
            let space = ''
            for (let list of this.myLists) {
              this.submitCodeStmt += space + ((typeof list.conj !== 'undefined') ? list.conj : (typeof list.codeStmt !== 'undefined') ? list.codeStmt : '')
              this.submitDescStmt += space + ((typeof list.descConj !== 'undefined') ? list.descConj : (typeof list.descStmt !== 'undefined') ? list.descStmt : '')
              space = ' '
            }
          }
        }
      },
      showAddList () {
        this.listDisp = true
      },
      viewList (index, editList) {
        this.myLists[index] = editList
        this.myLists[index].flgEdit = false
      },
      editList (index) {
        this.myLists[index].flgEdit = true
      },
      deleteList (index) {
        this.myLists.splice(index, 1)
      },
      linkList (index) {
        this.myLists[index].flgLink = true
      },
      unlinkList (index) {
        this.myLists[index].flgLink = false
      },
      groupList () {
        let linkedLists = this.myLists.filter(function (list) {
          return list.flgLink
        })
        this.validStmt = this.validateStmtLists(linkedLists)

        if (this.validStmt) {
          let statementIndex = this.myLists.map(function (list) { return list.id }).indexOf(linkedLists[0].id)
          for (let index = 0; index < linkedLists.length; index++) {
            let listIndex = this.myLists.map(function (list) {
              return list.id
            }).indexOf(linkedLists[index].id)
            if (listIndex > -1) {
              this.myLists.splice(listIndex, 1)
            }
            linkedLists[index].flgLink = false
          }
          if (linkedLists.length > 0) {
            let list = this.setStmt({ id: this.hashCode(), statement: linkedLists })
            this.myLists.splice(statementIndex, 0, list)
            this.$set(this.myLists[this.myLists.length - 1], 'flgEdit', false)
            this.$set(this.myLists[this.myLists.length - 1], 'flgLink', false)
          }
        }
      },
      ungroupList (index) {
        let statement = this.myLists[index].statement
        this.myLists.splice(index, 1)
        for (let i = statement.length - 1; i >= 0; i--) {
          this.myLists.splice(index, 0, statement[i])
        }
      },
      validateStmtLists (myLists) {
        let valid = true
        let flgStmt = true
        for (let list of myLists) {
          if ((typeof list.codeStmt !== 'undefined' && flgStmt) || (typeof list.conj !== 'undefined' && !flgStmt)) {
            flgStmt = !flgStmt
          } else {
            valid = false
            break
          }
        }
        return valid
      },
      setStmt (list) {
        if (typeof list.statement !== 'undefined') {
          let codeStmt = '('
          let descStmt = '('
          let space = ''
          for (let i = 0; i < list.statement.length; i++) {
            let statement = list.statement[i]
            if (typeof statement.descStmt !== 'undefined') {
              codeStmt += space + statement.codeStmt
              descStmt += space + statement.descStmt
            }
            if (typeof statement.descConj !== 'undefined') {
              codeStmt += space + statement.conj
              descStmt += space + statement.descConj
            }
            space = ' '
          }
          codeStmt += ')'
          descStmt += ')'
          list.codeStmt = codeStmt
          list.descStmt = descStmt
          return list
        }
      }
    }
  }
</script>

<style src="./style.scss" lang='scss'></style>



// WEBPACK FOOTER //
// component.vue?4c3c4416